<div class="L-tableUI__tableWrapper">
  <div
    *ngIf="!dataSource?.data"
    style="height: 55vh"
    class="flex justify-center items-center"
  >
    <ng-container *ngIf="primaryMessage; else defaultMessage">
      <p class="font-bold" i18n="@@apply_filters_and_click_fetch_records">
        Apply filters and click fetch records
      </p>
    </ng-container>
    <ng-template #defaultMessage>
      <p class="font-bold" i18n="@@fetch_list_of_records">
        Fetch list of records
      </p>
    </ng-template>
  </div>
  <div
    *ngIf="dataSource?.data && !dataSource.data.length"
    style="height: 55vh"
    class="flex justify-center items-center"
  >
    <p class="font-bold" i18n="@@no_records_found">No Records found</p>
  </div>
  <table
    #table
    id="grid"
    *ngIf="dataSource?.data?.length"
    mat-table
    [dataSource]="dataSource"
    (matSortChange)="announceSortChange($event)"
    class="L-tableUI__table"
    matSort
    [matSortActive]="matSortActive"
    [matSortDirection]="matSortDirection"
    cdkDropList
    [cdkDropListData]="dataSource.data"
    [cdkDropListDisabled]="!draggable || dragDisabled"
    (cdkDropListDropped)="onRowDrop($event)"
  >
    <ng-container
      *ngFor="let column of initColumns"
      [matColumnDef]="column.key"
      [sticky]="column.value === 'checkbox'"
    >
      <ng-container *ngIf="column.type === 'drag'">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button type="button" class="table-drag-handle" cdkDragHandle [disabled]="dragDisabled" aria-label="Reorder row">
            <img src="assets/icons/drag-drop-icon.svg" alt="">
          </button>
        </td>
      </ng-container>
      <!-- kindly check styles for checkbox styling -->
      <ng-container *ngIf="column.type === 'checkbox'">
        <th
          class="bg-background text-lg uppercase"
          mat-header-cell
          *matHeaderCellDef
        >
          <mat-checkbox
            (change)="onCheckAll($event)"
            [checked]="masterCheckboxChecked"
            *ngIf="showCheckboxes"
          ></mat-checkbox>
        </th>
        <td mat-cell class="text-sm" *matCellDef="let item">
          <mat-checkbox
            class="pr-3"
            (change)="onCheck($event, item)"
            [checked]="item.checked || false"
            *ngIf="showCheckboxes"
            [disabled]="item['disableCheckbox']"
            [ngClass]="item['disableCheckbox'] ? 'greyCheck' : ''"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- if reversal -->
      <ng-container *ngIf="column.type === 'reversal'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="" [matTooltip]="item[column.value]">
            {{ item[column.value] | truncate: column.maxLen | titlecase }}
            <span class="text-danger" *ngIf="item[column.isReversed] === true"
              >(reversed)</span
            >
          </span>
        </td>
      </ng-container>
      <!-- if text -->
      <ng-container *ngIf="column.type === 'text'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-error/50': item['deleted'] }"
            [matTooltip]="item[column.value]"
          >
            {{ item[column.value] | truncate: column.maxLen | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'status'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-error/50': item['deleted'] }"
            [matTooltip]="item[column.value]"
          >
            {{ item[column.value] | truncate: column.maxLen | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'btn'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-error/50': item['deleted'] }"
            [matTooltip]=""
          >
            <app-button-img-viewer
              [value]="item[column.value]"
            ></app-button-img-viewer>
          </span>
        </td>
      </ng-container>
      <!-- if email -->
      <ng-container *ngIf="column.type === 'email'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-error/50': item['deleted'] }"
            [matTooltip]="item[column.value]"
          >
            {{ item[column.value] | truncate: column.maxLen }}
          </span>
        </td>
      </ng-container>
      <!-- if boolean -->
      <ng-container *ngIf="column.type === 'boolean'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [ngClass]="column.class"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-error/50': item['deleted'] }"
            [matTooltip]="item[column.value]"
          >
            {{ item[column.value] | booleanValues }}
          </span>
        </td>
      </ng-container>
      <!-- if object access key in objectVal -->
      <ng-container *ngIf="column.type === 'object'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ item[column.value] | findValInObject: column.objectVal }}
          </span>
        </td>
      </ng-container>
      <!-- if number, use commas -->
      <ng-container *ngIf="column.type === 'number'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{
              column.decimals != null
                ? (item[column.value] | formatNumber: column.decimals)
                : (item[column.value] | numberWithComma)
            }}
          </span>
        </td>
      </ng-container>
      <!-- if id -->
      <ng-container *ngIf="column.type === 'id'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ item[column.value] }}
          </span>
        </td>
      </ng-container>
      <!-- if currency format with symbol -->
      <ng-container *ngIf="column.type === 'currency'">
        <th
          class="!text-right"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span class="!text-right">
            {{ column.hideHeaderSymbol ? column.name : (column.name | moneySymbol) }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm !text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            <ng-container *ngIf="item?.chargeType; else formatCurrency">
              <span *ngIf="item?.chargeType === 'FLAT'; else percentFormat">
                {{ item[column.value] | currency }}
              </span>
              <ng-template #percentFormat>
                {{ item[column.value] | wz_percentage_format_2 }}
              </ng-template>
            </ng-container>

            <ng-template #formatCurrency>
              {{ item[column.value] | currency }}
            </ng-template>
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'percentile'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ item[column.value] | wz_percentage_format_2 }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'date'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ item[column.value] | date: "dd/MM/yyyy" }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'dateTime'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="">
            {{ item[column.value] | date: "dd-MM-yyyy h:mm:ss a" }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'dateTimeMeridian'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="">
            {{ item[column.value] | date: "dd-MM-yyyy hh:mm a" }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customDateSelect'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <mat-form-field class="w-[50%]" appearance="outline">
            <input
              readonly
              [disabled]="true"
              matInput
              [min]="minDate"
              [matDatepicker]="picker"
              placeholder="Choose a date"
              (dateChange)="
                item[column.value] = $event.value.format('yyyy-MM-DD')
              "
              [value]="utils.formatDate_custom_yearFirst(item[column.value])"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customLoanOfficerSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm flex items-center gap-2 relative top-3"
          *matCellDef="let item; let i = index"
        >
          <app-loan-officer-search-select
            class="w-full"
            [disabled]="item.hasLoanOfficer"
            [areaId]="item.branch?.area?.id"
            [branchId]="item.branch?.id"
            (emitSelectedVal)="
              item[column.key] = $event?.id ?? item[column.key];
              leaderLoanOfficerAccountId = 0
            "
            [value]="item[column.value]"
          ></app-loan-officer-search-select>
          <button
            class="btn btn-sm btn-primary"
            style="margin-left: 24px"
            (click)="loanOfficerApplyToAll(item, column, i)"
            i18n="@@apply_to_all"
          >
            Apply to all
          </button>
          <button
            class="btn btn-sm btn-primary"
            style="margin-left: 12px"
            (click)="loanOfficerApplyToSelected(item, column, i)"
            i18n="@@apply_to_selected"
            title="Apply loan officer to selected items only"
          >
            Apply to Selected
          </button>
        </td>
      </ng-container>

      <!-- <ng-container *ngIf="column.type === 'customGlAccountSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td mat-cell class="text-sm" *matCellDef="let item; let i = index">
          <mat-form-field
            appearance="outline"
            class="w-[50%]"
            [ngClass]="disableGlAndFundsourceFIeld() && 'w-full'"
          >
            <mat-select
              [(value)]="item[column.value]"
              #glAccountSelect
              [disabled]="disableGlAndFundsourceFIeld()"
            >
              <mat-option
                *ngFor="
                  let account of item.branch?.branchGls || item.branchGls || []
                "
                [value]="account.id"
              >
                {{ account.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            [ngClass]="disableGlAndFundsourceFIeld() && 'hidden'"
            class="btn btn-sm {{
              leaderAccountId === item.id ? 'btn-primary' : 'btn-secondary'
            }}"
            style="margin-left: 24px"
            (click)="glAccountApplyToAll(item, column, i)"
            i18n="@@apply_to_all"
          >
            Apply to all
          </button>
        </td>
      </ng-container> -->
      <!-- 
      <ng-container *ngIf="column.type === 'customGlAccountSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item; let i = index"
          [ngClass]="{
            'bg-blue-50 border-l-4 border-l-blue-500': isSourceItem(item),
            'bg-green-50 border-l-4 border-l-green-400':
              hasMatchingGlAccount(item)
          }"
        >
          <div class="flex items-center gap-3 py-2">
          
            <div class="flex items-center gap-2 min-w-0 flex-1">
             
              <span
                *ngIf="isSourceItem(item)"
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-600 text-white"
              >
                <svg
                  class="w-3 h-3 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                  />
                </svg>
                Source
              </span>

        
              <span
                *ngIf="hasMatchingGlAccount(item)"
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-600 text-white"
              >
                <svg
                  class="w-3 h-3 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                Will update
              </span>

        
              <mat-form-field appearance="outline" class="flex-1">
                <mat-select
                  [(value)]="item[column.value]"
                  #glAccountSelect
                  [disabled]="disableGlAndFundsourceFIeld()"
                  (selectionChange)="previewGlAccountMatch(item, column)"
                >
                  <mat-option
                    *ngFor="
                      let account of item.branch?.branchGls ||
                        item.branchGls ||
                        []
                    "
                    [value]="account.id"
                  >
                    {{ account.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <button
              *ngIf="!disableGlAndFundsourceFIeld() || isSourceItem(item)"
              class="btn btn-sm whitespace-nowrap btn-primary"
              (click)="glAccountApplyToAll(item, column, i)"
            >
              Apply to all
              <span *ngIf="getMatchingItemsCount(item, column) > 1"
                >({{ getMatchingItemsCount(item, column) }})</span
              >
            </button>
          </div>
        </td>
      </ng-container> -->

      <ng-container *ngIf="column.type === 'customGlAccountSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let item; let i = index"
          [class.relative]="item._hasMatch"
        >
          <div class="flex items-center">
            <!-- Left section: Badge + Dropdown -->
            <div class="gl-account-controls">
              <!-- Match badge with fade animation -->
              <div
                *ngIf="item._hasMatch"
                class="badge-container absolute -top-0 left-[1.6rem] z-20"
              >
                <span class="match-badge">
                  <svg
                    class="w-3 h-3 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  Will update
                </span>
              </div>

              <!-- GL Account Select with managed width -->
              <mat-form-field appearance="outline" class="w-fit">
                <mat-select
                  [(value)]="item[column.value]"
                  #glAccountSelect
                  [disabled]="disableGlAndFundsourceFIeld()"
                  (selectionChange)="previewGlAccountMatch(item, column)"
                  placeholder="Select account"
                >
                  <mat-option
                    *ngFor="
                      let account of item.branch?.branchGls ||
                        item.branchGls ||
                        []
                    "
                    [value]="account.id"
                  >
                    {{ account.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Right section: Action button with reserved space -->
            <div
              *ngIf="item[column.value] && item._matchCount > 0"
              class="action-button- ml-3"
            >
              <button
                *ngIf="item[column.value] && item._matchCount > 0"
                class="btn btn-sm whitespace-nowrap btn-primary rounded-lg"
                (click)="glAccountApplytoAll(item, column, i)"
                [matTooltip]="getApplyButtonTooltip(item)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip"
                i18n-matTooltip="@@apply_gl_account_tooltip"
              >
                Apply to all
                <span> ({{ item._matchCount }}) </span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item; let i = index"
          [class.relative]="item._hasFundSourceMatch"
        >
          <div class="flex items-center">
            <!-- Left section: Badge + Dropdown -->
            <div class="fund-source-controls">
              <!-- Match badge with fade animation -->
              <div
                *ngIf="item._hasFundSourceMatch"
                class="badge-container absolute -top-0 left-0 z-20"
              >
                <span class="match-badge">
                  <svg
                    class="w-3 h-3 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  Will update
                </span>
              </div>

              <!-- Fund Source Select with managed width -->
              <mat-form-field
                appearance="outline"
                class="w-fit"
                [ngClass]="disableGlAndFundsourceFIeld() && 'w-full'"
              >
                <mat-select
                  [(value)]="item.fundSourceGlId"
                  #fundSourceSelect
                  [disabled]="disableGlAndFundsourceFIeld()"
                  (selectionChange)="previewFundSourceMatch(item, column)"
                  placeholder="Select fund source"
                >
                  <mat-option
                    *ngFor="
                      let fundSource of item.productId
                        | filterDisbursementFundsourcePipe: loanProducts
                    "
                    [value]="fundSource.glAccountId"
                  >
                    {{ fundSource.glAccountName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Right section: Action button with reserved space -->
            <div
              *ngIf="item.fundSourceGlId && item._fundSourceMatchCount > 0"
              class="action-button- ml-3"
            >
              <button
                *ngIf="
                  item.fundSourceGlId &&
                  item._fundSourceMatchCount > 0 &&
                  !disableGlAndFundsourceFIeld()
                "
                class="btn btn-sm whitespace-nowrap btn-primary"
                (click)="fundSourceApplytoAll(item, column, i)"
                [matTooltip]="getFundSourceApplyButtonTooltip(item)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip"
                i18n-matTooltip="@@apply_fund_source_tooltip"
              >
                Apply to all
                <span> ({{ item._fundSourceMatchCount }}) </span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customConfirmCheckbox'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td mat-cell class="text-sm whitespace-nowrap" *matCellDef="let item">
          <div
            *ngIf="confirmApplies(column, item); else confirmNotApplicable"
            class="confirm-cell"
            [class.confirm-cell--invalid]="confirmInvalid(column, item)"
          >
            <div class="flex items-center gap-1.5">
              <mat-checkbox
                color="primary"
                [checked]="!!item[column.value]"
                [disabled]="disableGlAndFundsourceFIeld()"
                (change)="onConfirmChange(column, item, $event.checked)"
                >{{ confirmLabel(column, item) }}</mat-checkbox
              >
              <span
                *ngIf="confirmTooltip(column, item) as tip"
                class="confirm-info"
                tabindex="0"
                role="img"
                [attr.aria-label]="tip"
                [matTooltip]="tip"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip multiline-tooltip"
                (mouseenter)="confirmInfoOpen(column, item)"
                (focus)="confirmInfoOpen(column, item)"
              >
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </span>
              <div
                *ngIf="
                  column.applyToAllOrSelected &&
                  !disableGlAndFundsourceFIeld() &&
                  isApplySource(column, item) &&
                  confirmApplyCount('all', column, item) > 0
                "
                class="flex items-center gap-3 ml-3"
              >
                <button
                  *ngIf="confirmApplyCount('all', column, item) > 0"
                  class="btn btn-sm whitespace-nowrap btn-primary"
                  (click)="applyConfirmTo('all', column, item)"
                >
                  <span i18n="@@apply_to_all">Apply to all</span>
                  <span> ({{ confirmApplyCount("all", column, item) }})</span>
                </button>
                <button
                  *ngIf="confirmApplyCount('selected', column, item) > 0"
                  class="btn btn-sm whitespace-nowrap btn-primary"
                  (click)="applyConfirmTo('selected', column, item)"
                >
                  <span i18n="@@apply_to_selected">Apply to Selected</span>
                  <span>
                    ({{ confirmApplyCount("selected", column, item) }})</span
                  >
                </button>
              </div>
            </div>
            <small
              *ngIf="confirmInvalid(column, item)"
              class="confirm-error"
              i18n="@@acc_field_required"
              >Required</small
            >
          </div>
          <ng-template #confirmNotApplicable>{{
            confirmLabel(column, item) || "-"
          }}</ng-template>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customOptionSelectPicker'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          [class.relative]="optionWillUpdate(column, item)"
        >
          <div class="flex items-center">
            <div class="fund-source-controls">
              <div
                *ngIf="optionWillUpdate(column, item)"
                class="badge-container absolute -top-0 left-0 z-20"
              >
                <span class="match-badge">
                  <svg
                    class="w-3 h-3 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  Will update
                </span>
              </div>

              <mat-form-field
                appearance="outline"
                class="w-fit"
                [ngClass]="disableGlAndFundsourceFIeld() && 'w-full'"
              >
                <mat-select
                  [(value)]="item[column.value]"
                  [disabled]="disableGlAndFundsourceFIeld()"
                  (selectionChange)="onOptionSelect(column, item)"
                  [placeholder]="column.placeholder || ''"
                >
                  <mat-option
                    *ngFor="let option of optionsFor(column, item)"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              *ngIf="
                showOptionApply(column, item) && !disableGlAndFundsourceFIeld()
              "
              class="action-button- ml-3"
            >
              <button
                class="btn btn-sm whitespace-nowrap btn-primary"
                (click)="applyOption(column, item)"
                [matTooltip]="optionApplyTooltip(column, item)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip"
              >
                {{ optionApplyText(column, item) }}
              </button>
            </div>

            <div
              *ngIf="
                column.applyToAllOrSelected &&
                !disableGlAndFundsourceFIeld() &&
                isApplySource(column, item) &&
                optionApplyCount('all', column, item) > 0
              "
              class="flex items-center gap-3 ml-3"
            >
              <button
                *ngIf="optionApplyCount('all', column, item) > 0"
                class="btn btn-sm whitespace-nowrap btn-primary"
                (click)="applyOptionTo('all', column, item)"
              >
                <span i18n="@@apply_to_all">Apply to all</span>
                <span> ({{ optionApplyCount("all", column, item) }})</span>
              </button>
              <button
                *ngIf="optionApplyCount('selected', column, item) > 0"
                class="btn btn-sm whitespace-nowrap btn-primary"
                (click)="applyOptionTo('selected', column, item)"
              >
                <span i18n="@@apply_to_selected">Apply to Selected</span>
                <span> ({{ optionApplyCount("selected", column, item) }})</span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customInput'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td mat-cell class="text-sm" *matCellDef="let item; let i = index">
          <mat-form-field appearance="outline" class="w-[50%]">
            <input
              type="tel"
              matInput
              appCurrency
              [(ngModel)]="item[column.value]"
              (ngModelChange)="
                customInputChange.emit({ item: item, column: column })
              "
            />
          </mat-form-field>
          <button
            class="btn btn-sm btn-primary btn-secondary"
            style="margin-left: 24px"
            (click)="applyToAllCustomInput(item[column.value], column.value)"
            i18n="@@apply_to_all"
          >
            Apply to all
          </button>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'phone'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ item[column.value] | wz_phone_number }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'multiValue'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-error/50': item['deleted'] }">
            {{ column.values | mergeMultiValues: item | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'actions'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
        >
          <div class="document-actions">
            <button
              mat-icon-button
              type="button"
              class="table-action-button table-edit-button"
              (click)="onEditAction(item); $event.stopPropagation()"
              [attr.aria-label]="'Edit'"
              i18n-aria-label="@@edit"
            >
              <span class="edit-icon" aria-hidden="true"></span>
            </button>
            <button
              mat-icon-button
              type="button"
              class="table-action-button"
              (click)="onDeleteAction(item); $event.stopPropagation()"
              [attr.aria-label]="'Delete'"
              i18n-aria-label="@@delete"
            >
              <img src="assets/icons/delete-bin.svg" alt="">
            </button>
          </div>
        </td>
      </ng-container>

      <!-- totals row, shared by every column type. Only rendered when
      showFooter is set; the value comes from the column's footer prop -->
      <td
        mat-footer-cell
        *matFooterCellDef
        class="text-sm"
        [ngClass]="{ '!text-right': isNumericFooter(column) }"
      >
        <span *ngIf="column.footer !== null && column.footer !== undefined">
          {{
            isNumericFooter(column)
              ? (column.footer | formatNumber)
              : column.footer
          }}
        </span>
      </td>

      <!-- if more (...) -->
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <ng-container *ngIf="!usePermission">
      <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row" [cdkDragDisabled]="!draggable || dragDisabled"></tr>
    </ng-container>
    <ng-container *ngIf="usePermission">
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        cdkDrag
        [cdkDragData]="row"
        [cdkDragDisabled]="!draggable || dragDisabled"
        [class.hidden]="!hasPermission(row.perms)"
      ></tr>
    </ng-container>
    <ng-container *ngIf="showFooter">
      <tr
        mat-footer-row
        *matFooterRowDef="displayedColumns; sticky: true"
        class="font-semibold"
      ></tr>
    </ng-container>
  </table>
</div>
<app-pagination-ui
  (togglePageControlEmit)="onPageCtrlToggle($event)"
  (pageSizeToggleEmit)="onPageSizeToggle($event)"
  [showPagination]="showPagination"
  [pageProp]="pageProp"
></app-pagination-ui>
